import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { countByTopicsLastXDays } from "../../../api/statistics/topic/TopicStatisticsAPI";
import RandomColor from "../../../util/RandomColor";
import { Typography } from "@mui/material";
import { Chart as ChartJS, registerables } from "chart.js";
import { curveLineOptions } from "../../../util/ChartStyleUtil";
import { errorNoti } from "../../../util/SnackbarMessage";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
ChartJS.register(...registerables);
type DayProps = {
  day: number;
};

const options = {
  plugins: {
    // title: {
    //   display: true,
    //   text: "Số bài báo theo chủ đề",
    // },
    legend: {
      position: "right" as const,
      align: "center" as const,
      labels: {
        boxWidth: 20,
        font: {
          size: 10,
        },
      },
    },
  },
  responsive: true,
  elements: curveLineOptions().elements,
};

function TopicStackedChartWrapper(props: DayProps) {
  const [topicData, setTopicData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(["error"]);
  useEffect(() => {
    countByTopicsLastXDays(props.day)
      .then((response) => setTopicData(response))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [props.day]);

  const dayLabels = [
    ...new Set(
      topicData.map((topic) => {
        return topic["time"];
      })
    ),
  ];

  const topicLabels = [
    ...new Set(
      topicData.map((topic) => {
        return topic["topic"];
      })
    ),
  ];

  function topicCount(topic: string) {
    return topicData.filter((top) => {
      return top["topic"] === topic;
    });
  }

  let colors = new Map(
    topicLabels.map((topic) => [topic, RandomColor({ name: topic })])
  );

  const datasets = topicLabels.map(function (topicLabel) {
    const counts = topicCount(topicLabel).map((topic) => topic["count"]);
    return {
      label: topicLabel,
      data: counts,
      backgroundColor: colors.get(topicLabel),
      borderColor: colors.get(topicLabel),
    };
  });

  const data = {
    labels: dayLabels,
    datasets: datasets,
  };
  return (
    <div>
      <Typography variant="h6">
        Số bài báo theo chủ đề - {props.day} ngày gần nhất
      </Typography>
      <Line options={options} data={data} style={{ marginTop: "15px" }}></Line>
    </div>
  );
}
export default TopicStackedChartWrapper;
